import React from 'react';

const MoCRA: React.FC = () => {
  return (
    <main className="min-h-screen bg-white">
      <section className="pt-32 pb-12 bg-gradient-to-br from-indigo-50 via-white to-blue-50">
        <div className="max-w-5xl mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">MoCRA Compliance for Cosmetics Companies</h1>
          <p className="text-lg text-gray-700 max-w-3xl">A practical guide to the Modernization of Cosmetics Regulation Act (MoCRA) and how CosmaComply helps you operationalize compliance: facility registration, cosmetic product listing, adverse event reporting (cosmetovigilance), and safety substantiation with TRA.</p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-5xl mx-auto px-4 space-y-10">
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">What is MoCRA?</h2>
            <p className="text-gray-700">MoCRA updates FDA oversight of cosmetics in the U.S., introducing explicit obligations for facility registration, product listing, safety substantiation, adverse event reporting, and recordkeeping.</p>
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Facility Registration</h2>
            <p className="text-gray-700">Manufacturing/processing facilities must register with the FDA and renew periodically. CosmaComply provides structured data capture, renewal reminders, and audit logs.</p>
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Cosmetic Product Listing</h2>
            <p className="text-gray-700">Responsible persons must list marketed cosmetic products and keep listings updated. CosmaComply helps prepare FDA-ready records and track changes across SKUs and variants.</p>
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Adverse Event Reporting (Cosmetovigilance)</h2>
            <p className="text-gray-700">Identify potential serious adverse events, triage, and track reporting timelines. CosmaComply supports case intake, seriousness assessment, and activity logging.</p>
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Safety Substantiation & TRA</h2>
            <p className="text-gray-700">Generate Toxicological Risk Assessments (SED/MoS) and safety dossiers. Export professional PDFs and maintain versioned, auditable evidence. CosmaComply is not affiliated with or approved by the FDA.</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default MoCRA;
